"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchLeadSurveyRelatedPropertiesFailure = exports.fetchLeadSurveyRelatedPropertiesSuccess = exports.fetchLeadSurveyRelatedProperties = exports.setQuestionError = exports.submitLeadSurveyFailure = exports.submitLeadSurveySuccess = exports.submitLeadSurvey = exports.loadLeadSurveySuccess = exports.loadLeadSurveyFailure = exports.loadLeadSurvey = exports.sendAnswersSuccess = exports.sendAnswersFailure = exports.sendAnswers = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const initialState = {
    isLeadSurveyCompleted: false,
    isLoading: false,
    leadSurveyId: '',
    questionsResponses: {},
    sellerName: '',
    email: ''
};
const leadSurveySlice = (0, toolkit_1.createSlice)({
    name: 'leadSurvey',
    initialState,
    reducers: {
        loadLeadSurvey(state, action) {
            state.isLoading = true;
            state.leadSurveyId = action.payload.leadSurveyId;
        },
        loadLeadSurveySuccess(state, action) {
            state.isLoading = false;
            state.group = action.payload.group;
            state.error = undefined;
            state.questionsResponses = action.payload.questionsResponses.reduce((carry, questionResponses) => {
                return {
                    ...carry,
                    [questionResponses.question_id]: questionResponses
                };
            }, {});
            state.isLeadSurveyCompleted = action.payload.isLeadSurveyCompleted;
            state.sellerName = action.payload.sellerName;
            state.email = action.payload.email;
        },
        loadLeadSurveyFailure(state, action) {
            state.isLoading = false;
            state.error = action.payload;
        },
        setQuestionError(state, action) {
            state.isLoading = false;
            if (state.group) {
                for (const question of state.group.questions) {
                    if (question.id === action.payload) {
                        question.hasError = true;
                    }
                }
            }
        },
        sendAnswers(state, action) {
            state.questionsResponses[action.payload.question_id] = action.payload;
            state.isLoading = true;
            if (state.group) {
                for (const question of state.group.questions) {
                    if (question.id === action.payload.question_id) {
                        question.hasError = false;
                    }
                }
            }
        },
        sendAnswersSuccess(state) {
            state.isLoading = false;
        },
        sendAnswersFailure(state, action) {
            state.isLoading = false;
            state.error = action.payload;
        },
        submitLeadSurvey(state) {
            state.isLoading = true;
        },
        submitLeadSurveySuccess(state, action) {
            state.isLoading = false;
            state.isLeadSurveyCompleted = action.payload.isLeadSurveyCompleted;
            state.sellerName = action.payload.sellerName;
            state.email = action.payload.email;
        },
        submitLeadSurveyFailure(state, action) {
            state.isLoading = false;
            state.error = action.payload;
        },
        fetchLeadSurveyRelatedProperties(state) {
            state.isLoading = true;
        },
        fetchLeadSurveyRelatedPropertiesSuccess(state, action) {
            state.isLoading = false;
            state.relatedProperties = action.payload;
        },
        fetchLeadSurveyRelatedPropertiesFailure(state, action) {
            state.isLoading = false;
            state.error = action.payload;
        }
    }
});
_a = leadSurveySlice.actions, exports.sendAnswers = _a.sendAnswers, exports.sendAnswersFailure = _a.sendAnswersFailure, exports.sendAnswersSuccess = _a.sendAnswersSuccess, exports.loadLeadSurvey = _a.loadLeadSurvey, exports.loadLeadSurveyFailure = _a.loadLeadSurveyFailure, exports.loadLeadSurveySuccess = _a.loadLeadSurveySuccess, exports.submitLeadSurvey = _a.submitLeadSurvey, exports.submitLeadSurveySuccess = _a.submitLeadSurveySuccess, exports.submitLeadSurveyFailure = _a.submitLeadSurveyFailure, exports.setQuestionError = _a.setQuestionError, exports.fetchLeadSurveyRelatedProperties = _a.fetchLeadSurveyRelatedProperties, exports.fetchLeadSurveyRelatedPropertiesSuccess = _a.fetchLeadSurveyRelatedPropertiesSuccess, exports.fetchLeadSurveyRelatedPropertiesFailure = _a.fetchLeadSurveyRelatedPropertiesFailure;
exports.default = leadSurveySlice.reducer;
//# sourceMappingURL=slice.js.map